import { Reveal } from "@/components/Reveal";

const OUTCOME_CHIPS = [
  "Europe & US clients",
  "10 yrs shipping",
  "Boutique senior team"
];

const INDUSTRY_CHIPS = [
  "Hospitality",
  "Finance"
];

const TrustBand = () => {
  return (
    <section className="border-t border-border/20 bg-background/50">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        
        {/* Soft proof chips */}
        <Reveal>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            {OUTCOME_CHIPS.map((chip, i) => (
              <div
                key={chip}
                className="rounded-full border-2 border-coral/20 bg-coral/5 px-4 py-2 font-mono text-sm font-medium tracking-wide text-coral transition-all duration-300 hover:border-coral/40 hover:bg-coral/10 sm:px-5 sm:py-2.5"
              >
                {chip}
              </div>
            ))}
          </div>
        </Reveal>

        {/* Industry focus */}
        <Reveal delay={0.1} className="mt-12">
          <div className="text-center">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
              Industries served
            </span>
            <div className="mt-6 flex flex-wrap justify-center gap-6 sm:gap-8">
              {INDUSTRY_CHIPS.map((industry, i) => (
                <div
                  key={industry}
                  className="flex h-12 items-center justify-center rounded-lg border border-border bg-card px-4 py-2 font-mono text-sm font-medium text-muted-foreground transition-all duration-300 hover:border-coral/20 hover:text-foreground sm:h-14 sm:px-6"
                >
                  {industry}
                </div>
              ))}
            </div>
          </div>
        </Reveal>

      </div>
    </section>
  );
};

export default TrustBand;